import React from "react";
import { useCart } from "hooks/useStore";
import { ReactComponent as Trash } from "svgs/trash.svg";
import ItemPrices from "./prices";
import Loader from "components/loader";
import { SHIPPING_PROTECTION_KEY } from "utils/constants";

const ShippingProtectionItem = ({ product, isRemoving, handleRemoveItem }) => {
	const { shippingProtection, updateAttributes, attributes } = useCart(["shippingProtection", "updateAttributes", "attributes"]);

	const handleRemove = async () => {
		if (shippingProtection.selected) {
			if (!attributes.some(attr => attr.key === SHIPPING_PROTECTION_KEY)) {
				await updateAttributes([{ key: SHIPPING_PROTECTION_KEY, value: "false" }]);
			}
			await handleRemoveItem();
		}
	};

	return (
		<div className="cart-item sp-cart-item">
			<div className="cart-item-content">
				<div className="cart-item-header w-full">
					<div className="flex flex-col gap-y-6 sm:gap-y-4 w-3/4">
						<h4 className="text-left">{product.title}</h4>
						<span className="text-xs sm:text-sm">
							Full replacement if your package is lost, damaged, or stolen — no questions asked.</span>
					</div>
					<div className="flex flex-col items-center justify-center mb-auto gap-y-2 sm:gap-y-1">
						<button disabled={isRemoving} className="bg-cream p-2 !ml-auto  size-10" onClick={handleRemove}>
							{isRemoving ? <Loader /> : <Trash className="scale-[0.667]" />}
						</button>
						<ItemPrices
							price={product.variant.discountedPrice}
							compareAtPrice={product.variant.compareAtPrice}
							currency={product.currency} />
					</div>
				</div>
				{product.discounts?.length > 0 &&
					<span className="text-sm flex gap-2">
						{product.discounts.map((discount) =>
							discount?.amount > 0 && discount?.title &&
							<span key={discount?.title} className="capitalize text-xs text-pureRed tracking-wider">
								{discount.title}
							</span>)}
					</span>
				}
			</div>
		</div>
	);
};

export default ShippingProtectionItem;